import React from "react";
const NotFound404 = () => {
  return <div>404 Not Found</div>;
};

export default NotFound404;
